import { render, staticRenderFns } from "./MailSnippet.vue?vue&type=template&id=74dbfcc1&"
import script from "./MailSnippet.vue?vue&type=script&lang=js&"
export * from "./MailSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports